import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 200
    },
    root: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    container: {
        display: 'block',
        flexDirection: 'column',
        alignItems: 'center'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main
    },
    errorIcon: {
        color: theme.palette.error.main
    },
    successIcon: {
        color: theme.palette.success.main
    },
    signUpIcon: {
        color: 'white'
    },
    // progress bar
    progress: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    disciplineContainer: {
        minWidth: 400 + theme.spacing(2),
        margin: theme.spacing(1),
    },
    dropdownLabel: {
        backgroundColor: theme.palette.background.default
    }
}));

export {useStyles};